<h1 class="page-title">Pay &amp; Schedule Exam</h1>
<div
    *ngIf="recertificationFlag"
    class="form-section"
>
    <strong>
        You are applying for the TMC exam to recertify your CRT credential, this attempt will not apply for CSE eligibility.  If you want to attempt to qualify for the CSE examination please call our office at 913.895.4900.
    </strong>
</div>
<div
    *ngIf="timeLimitEndDate"
    class="form-section"
>
    Graduates of advanced-level programs are required to earn the RRT credentials within three years of graduation.
    <strong>
        Our records indicate your three-year time limit is {{exam?.timeLimitEndDate  | amDateFormat: 'L':'UTC'}}. If you apply for the examination now, your examination appointment cannot be scheduled past this date.
    </strong>
    If you do not earn the RRT credential within the time limit, you will be required to retake and pass the TMC Examination at the high cut score to regain eligibility; any previous passing performance to earn the RRT credential is nullified. You must apply as a new candidate and pay all applicable fees to take the TMC and CSE Examinations.
</div>
<div
    *ngIf="expirationDate"
    class="form-section"
>
    <strong>
        Our records indicate your credential expires on {{exam?.expirationDate  | amDateFormat: 'L'}}. If you apply for the examination now, your examination appointment cannot be scheduled past this date.
    </strong>
</div>
<div
    *ngIf="showEligDates && !showWaitMessage && purchase.total != 0"
    class="form-section"
>
    <strong>
        If you continue with the application process today, your eligibility period to take this exam will be between {{exam?.eligibilityBeginDate  | amDateFormat: 'L'}} and {{exam?.eligibilityEndDate  | amDateFormat: 'L'}}.
    </strong>
</div>

<div
    *ngIf="showEligDates && !showWaitMessage && purchase.total == 0"
    class="form-section"
>
    <strong>
        To claim your second-chance-free examination, you must reapply and take the same examination by {{freeServiceExpiration| amDateFormat:'MMMM Do, YYYY'}}. If you continue with the application process today, your eligibility period to take this exam will be between
     {{exam?.eligibilityBeginDate  | amDateFormat: 'L'}} and {{exam?.eligibilityEndDate  | amDateFormat: 'L'}}. Complete the information requested below and hit ‘Submit’ to complete the reapplication process.
    </strong>
</div>

<div
    *ngIf="showEligDates && showWaitMessage"
    class="form-section"
    style="color: red"
>
    <strong *ngIf="!showShortTYTLWarning() && !showExpirationWarning()">
        You may apply and pay for the examination at this time, however, because of the repeat attempt policy, the first date you may take the examination is {{exam?.eligibilityBeginDate  | amParse:'YYYY/MM/Do' | amDateFormat: 'L'}} and the last day you may take the examination without forfeiture of your application fee is {{exam?.eligibilityEndDate  | amDateFormat: 'L' :'UTC'}}.
    </strong>
    <strong *ngIf="showShortTYTLWarning()">
        You may apply and pay for the examination at this time, however, because of the repeat attempt policy and three-year RRT eligibility time limit, you will not receive the full 90-days of eligibility. The first date you may take the examination is {{exam?.eligibilityBeginDate  | amDateFormat: 'L':'UTC'}} and 
    the last date you may take the examination without forfeiture of your application fee is {{exam?.eligibilityEndDate | amDateFormat: 'L'}}. 
    To submit your application, complete the information below.
    </strong>
    <strong *ngIf="showExpirationWarning()">
        You may apply and pay for the examination at this time, however, because of the repeat attempt policy and your credential expiration date, you will not receive the full 90-days of eligibility. The first date you may take the examination is {{exam?.eligibilityBeginDate  | amDateFormat: 'L':'UTC'}}
    and the last date you may take the examination without forfeiture of your application fee is {{exam?.eligibilityEndDate  | amDateFormat: 'L'}}. To submit your application, complete the information below.
    </strong>

</div>
<div
    *ngIf="licensureExam"
    class="form-section"
    style="color: red"
>
    This examination is for state licensure purposes only.  If you have any questions about your state licensure examination, contact the state regulatory agency directly. You do not meet the NBRC’s requirements for the CRT or RRT credential and you cannot use the federally trademarked designation(s) if successful on the examination.
</div>

<div
    *ngIf="examInstructions"
    class="form-section"
>
    <strong>{{examInstructions}}</strong>
</div>
<div
    *ngIf="reinstatementFee"
    class="form-section"
>
    <strong>
        A one-time reinstatement fee is required due to your expired credential status.
    </strong>
</div>
<app-product-list [customPurchase]="purchase"></app-product-list>
<form
    [formGroup]="checkoutForm"
    (ngSubmit)="onSubmit(checkoutForm.value)"
>
    <div
        class="form-section"
        *ngIf="!collectBirthday && !collectDemographics"
    >
        <fieldset class="field-group field-group--inline">
            <legend class="label field-group__label field-group__label--inline ">
                Do you require special accommodations during testing?
            </legend>
            <ul class="field-list field-list--inline">
                <li class="field field--inline field-list__item field-list__item--inline">
                    <input
                        class="input input--radio "
                        id="special-accommodations-yes"
                        name="specialAccommodations"
                        formControlName="specialAccommodations"
                        [value]="true"
                        type="radio"
                    >
                    <label
                        for="special-accommodations-yes"
                        class="label label--inline"
                    >
                        Yes
                    </label>
                </li>
                <li class="field field--inline field-list__item field-list__item--inline">
                    <input
                        class="input input--radio "
                        id="special-accommodations-no"
                        name="specialAccommodations"
                        formControlName="specialAccommodations"
                        [value]="false"
                        type="radio"
                        [checked]="true"
                    >
                    <label
                        for="special-accommodations-no"
                        class="label label--inline  "
                    >
                        No
                    </label>
                </li>
            </ul>
        </fieldset>
        <p>
            If you have not previously been provided accommodations for an NBRC examination,
            <span style="color: red;">
                you must complete and submit the
                <a
                    href="https://www.nbrc.org/doc/special-accommodations-request"
                    target="_blank"
                >
                    Request for
      Special Examination Accommodations form
                </a>
                <strong>PRIOR</strong>
                to making payment.
            </span>
        </p>
        <p>
            If the form is not received prior to making payment and scheduling a testing appointment, approved accommodations will not be provided for your scheduled examination.
        </p>
        <p>
            You may call our office at 913-895-4900 to check the status of your special accommodations request.
        </p>
        <!-- <fieldset class="field-group field-group--inline">
      <legend class="label field-group__label field-group__label--inline ">Are you applying for an international testing location*?
      </legend>
      <ul class="field-list field-list--inline">
        <li class="field field--inline field-list__item field-list__item--inline">
          <input class="input input--radio " id="international-testing-yes" name="internationalTesting" formControlName="internationalTesting" [value]="true" type="radio">
          <label for="international-testing-yes" class="label label--inline">Yes</label>
        </li>
        <li class="field field--inline field-list__item field-list__item--inline">
          <input class="input input--radio " id="international-testing-no" name="internationalTesting" formControlName="internationalTesting" [value]="false" type="radio" [checked]="true">
          <label for="international-testing-no" class="label label--inline  ">No</label>
        </li>
      </ul>
    </fieldset>
    <p>Individuals testing outside the United States or its territories will be required to pay an additional $150 fee.
      A list of international locations is provided at goAMP.com. Only the sites listed will be considered and this list is subject to change due to availability.
    </p>
    <p>*If you are active military personnel serving outside the United States and wish to test at your facility, please contact our office at 913.895.4900 for instructions.
      </p> -->
    </div>

    <fieldset
        class="form-section"
        *ngIf="collectDiscipline"
    >
        <p>
            I am a currently licensed or credentialed U.S. health care professional active and unrestricted in the following profession. 
        I understand that audits of first time candidates is a routine part of NBRC’s commitment of ensuring public safety and complying 
        with standard regulatory practices. If selected for audit, I will be notified on screen and by email and will have a period of 
        two weeks to submit the required documentation.
        </p>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="discipline"
                    class="label"
                >
                    License or Credential
                </label>
                <select
                    class="input input--select-menu input--xlarge"
                    [class.input--invalid]="formErrors.discipline"
                    id="discipline"
                    formControlName="discipline"
                >
                    <option value>Select One</option>
                    <option
                        *ngFor="let c of disciplineLov"
                        [value]="c.codeValue"
                    >
                        {{c.codeDescription}}
                    </option>
                    <option value="S">Student</option>
                </select>
                <div
                    *ngIf="formErrors.discipline"
                    class="error-message field__error-message"
                >
                    {{ formErrors.discipline }}
                </div>
            </div>
        </div>
        <div *ngIf="collectDiscipline && disciplinePicked==30">
            If you are applying for the examination with 1,000 hours of direct patient asthma education, counseling or coordinating services you must 
      submit a
            <a href="https://nbrc.org/ae-c-application">paper application</a>
            form and payment. If you do not have an active US license or credential, 
      you must apply under this eligibility route.
        </div>
        <div *ngIf="collectDiscipline && (disciplinePicked==4||disciplinePicked==5)">
            We don't show an active credential in our system, unable to apply under this route.
        </div>
        <div *ngIf="collectDiscipline && disciplinePicked=='S'">
            You do not qualify for the examination until you are currently licensed or an active and unrestricted credentialed health care professional.
        </div>
        <div *ngIf="validDiscipline">
            <br>
            <button
                (click)="submitDiscipline($event);"
                [disabled]="isProcessing"
                class="button form-actions__item"
                type="button"
            >
                Update Discipline to Apply
            </button>
        </div>
    </fieldset>

    <div *ngIf="disciplineAudit">
        <p>
            Your discipline was updated. Your record has been selected for audit. To complete the application process, 
          you must submit proof of your selected license or credential. You may do this by going back to the main page and uploading a PDF.  You can also email a PDF copy to
            <a href="mailto:apply@nbrc.org.">apply@nbrc.org</a>
            .
        </p>
        <p>
            When your audit is complete you will receive an email with instructions to complete the application process or with further instructions. 
          You may login to the
            <a href="/auth">Practitioner Portal</a>
            to check the status of your audit; however, you should allow two weeks for processing 
          once your documentation has been received.
        </p>
        <p>
            Please contact our office at
            <a href="mailto:apply@nbrc.org.">apply@nbrc.org</a>
            or 913.895.4900 if you have any questions.
        </p>
    </div>

    <div
        class="form-section"
        *ngIf="collectBirthday"
    >
        <div>
            Please enter your date of birth below to confirm you meet the minimum age requirement to apply for NBRC examinations.
        </div>
        <br>
        <fieldset
            class="field-group"
            [formGroup]="DOBForm"
        >
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="dob"
                        class="label"
                    >
                        Date of Birth
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.dob"
                        id="dob"
                        placeholder="MM/DD/YYYY"
                        formControlName="dob"
                        mask="00/00/0000"
                    >
                    <div
                        *ngIf="formErrors.dob"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.dob }}
                    </div>
                </div>
            </div>
            <br>
            <button
                (click)="submitDOB($event);"
                [disabled]="isProcessing"
                class="button form-actions__item"
                type="button"
            >
                Update
            </button>
        </fieldset>
    </div>

    <div *ngIf="collectDemographics">
        <p>
            Providing the requested background information is voluntary and will not be provided to any third party or otherwise be shared publicly. 
      Your participation is encouraged because this information will be used to evaluate the fairness of examination content.
        </p>
        <fieldset
            class="field-group"
            [formGroup]="DemographicForm"
        >
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="gender"
                        class="label"
                    >
                        With which of the following do you identify?
                    </label>
                    <select
                        class="input input--select-menu input--xlarge"
                        id="gender"
                        name="gender"
                        formControlName="gender"
                        [class.input--invalid]="formErrors.gender"
                    >
                        <option value>Select One</option>
                        <option value="F">Female</option>
                        <option value="M">Male</option>
                        <option value="N">Non-binary</option>
                        <option value="P">Prefer not to say</option>
                    </select>
                    <div
                        *ngIf="formErrors.gender"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.gender }}
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="spanishOrigin"
                        class="label"
                    >
                        Do you identify with an Hispanic, Latino, or Spanish origin?
                    </label>
                    <select
                        class="input input--select-menu input--xlarge"
                        id="spanishOrigin"
                        name="spanishOrigin"
                        formControlName="spanishOrigin"
                        [class.input--invalid]="formErrors.spanishOrigin"
                    >
                        <option value>Select One</option>
                        <option value="1">No</option>
                        <option value="2">Yes</option>
                        <option value="9">Prefer not to say</option>
                    </select>
                    <div
                        *ngIf="formErrors.spanishOrigin"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.spanishOrigin }}
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="race"
                        class="label"
                    >
                        With which of the following do you PRIMARILY identify?
                    </label>
                    <select
                        class="input input--select-menu input--xlarge"
                        id="race"
                        name="race"
                        formControlName="race"
                        [class.input--invalid]="formErrors.race"
                    >
                        <option value>Select One</option>
                        <option value="1">American Indian or Alaskan Native</option>
                        <option value="2">Asian</option>
                        <option value="3">Black or African American</option>
                        <option value="4">
                            Native Hawaiian or Other Pacific Islander
                        </option>
                        <option value="5">Two or More Races</option>
                        <option value="6">White</option>
                        <option value="9">Prefer not to say</option>
                    </select>
                    <div
                        *ngIf="formErrors.race"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.race }}
                    </div>
                </div>
            </div>
        </fieldset>
        <div class="form-actions">
            <button
                (click)="submitDemoGraphic($event);"
                [disabled]="isProcessing"
                class="button form-actions__item"
                type="button"
            >
                Update
            </button>
        </div>
    </div>

    <div class="form-section"></div>
    <fieldset
        class="field-group"
        *ngIf="!collectBirthday && !collectDemographics &&!collectDiscipline && !disciplineAudit && purchase.total != 0"
    >
        <legend>Payment Options</legend>
        <section>
            <h3>Select payment method</h3>
            <div
                class="form-row"
                style="width:100%;"
            >
                <ul class="field-list field-list__item">
                    <li class="field field--inline field-list__item field-list__item--inline">
                        <input
                            class="input input--radio"
                            id="paymentType"
                            value="CC"
                            name="paymentType"
                            type="radio"
                            (change)="changePaymentType($event.target.value)"
                        >
                        <label
                            for="paymentType"
                            class="label label--inline"
                        >
                            Credit Card
                        </label>
                    </li>
                    <!-- <li class="field field--inline field-list__item field-list__item--inline">
            <input class="input input--radio" id="paymentType" value="ACH" name="paymentType" type="radio" (change)="changePaymentType($event.target.value)"/>
            <label for="paymentType" class="label label--inline">Check (enter your bank routing number and checking account number for payment)</label>
          </li> -->
                    <li class="field field--inline field-list__item field-list__item--inline">
                        <input
                            class="input input--radio"
                            id="paymentType"
                            value="V"
                            name="paymentType"
                            type="radio"
                            (change)="changePaymentType($event.target.value)"
                        >
                        <label
                            for="paymentType"
                            class="label label--inline"
                        >
                            Voucher
                        </label>
                    </li>
                </ul>
            </div>
            <div
                *ngIf="formErrors.paymentType"
                class="error-message field__error-message"
            >
                {{ formErrors.paymentType }}
            </div>
        </section>

        <div
            *ngIf="paymentType=='CC'"
            class="field-list__item payment-option-item"
        >
            <div class="nested-fields">
                <div class="field">
                    <div class="field__label-input-wrap">
                        <label
                            for="nameOnCard"
                            class="label"
                        >
                            Name on Card
                        </label>
                        <input
                            class="input input--large"
                            [class.input--invalid]="formErrors.nameOnCard"
                            [class.input--invalid]="formErrors.nameOnCard"
                            id="nameOnCard"
                            formControlName="nameOnCard"
                            requiredIf="paymentType"
                            requiredIfValue="CC"
                            maxlength="35"
                        >
                        <div
                            *ngIf="formErrors.nameOnCard"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.nameOnCard }}
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="field form-row__item form-row__item--medium">
                        <div class="field__label-input-wrap">
                            <label
                                for="cardNumber"
                                class="label"
                            >
                                Card Number
                            </label>
                            <div
                                class="credit-card-number-input-wrap"
                                [class.credit-card-number-input-wrap--populated]="ccType"
                                [class.credit-card-number-input-wrap--amex]="ccType === cardTypes.Amex"
                                [class.credit-card-number-input-wrap--discover]="ccType === cardTypes.Discover"
                                [class.credit-card-number-input-wrap--mastercard]="ccType === cardTypes.MasterCard"
                                [class.credit-card-number-input-wrap--visa]="ccType === cardTypes.Visa"
                            >
                                <input
                                    class="input input--medium"
                                    [class.input--invalid]="formErrors.cardNumber"
                                    formControlName="cardNumber"
                                    id="cardNumber"
                                    mask="0000 0000 0000 0000"
                                    [dropSpecialCharacters]="true"
                                    requiredIf="paymentType"
                                    requiredIfValue="CC"
                                >
                            </div>
                            <div
                                *ngIf="formErrors.cardNumber"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.cardNumber }}
                            </div>
                        </div>
                    </div>
                    <div class="field form-row__item">
                        <div class="field__label-input-wrap">
                            <label
                                for="expirationDate"
                                class="label"
                            >
                                Exp. Date
                            </label>
                            <input
                                class="input input--small"
                                [class.input--invalid]="formErrors.expirationDate"
                                formControlName="expirationDate"
                                id="expirationDate"
                                placeholder="MM/YY"
                                mask="00/00"
                                requiredIf="paymentType"
                                requiredIfValue="CC"
                            >
                            <div
                                *ngIf="formErrors.expirationDate"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.expirationDate }}
                            </div>
                        </div>
                    </div>
                    <div class="field form-row__item">
                        <div class="field__label-input-wrap">
                            <label
                                for="ccv"
                                class="label"
                            >
                                CCV
                            </label>
                            <input
                                class="input input--small"
                                [class.input--invalid]="formErrors.ccv"
                                formControlName="ccv"
                                id="ccv"
                                pattern="[0-9]{3,4}"
                                placeholder="123"                                
                                requiredIf="paymentType"
                                requiredIfValue="CC"
                            >
                            <div
                                *ngIf="formErrors.ccv"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.ccv }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="field__label-input-wrap">
                        <label
                            for="country"
                            class="label"
                        >
                            Country
                        </label>
                        <select
                            class="input input--select-menu input--large"
                            [class.input--invalid]="formErrors.countryId"
                            id="country"
                            formControlName="countryId"
                        >
                            <option value>Select One</option>
                            <option
                                *ngFor="let c of countries"
                                [value]="c.id"
                            >
                                {{c.description}}
                            </option>
                        </select>
                        <div
                            *ngIf="formErrors.countryId"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.countryId }}
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="field__label-input-wrap">
                        <label
                            for="address"
                            class="label"
                        >
                            Address
                        </label>
                        <input
                            class="input input--large"
                            [class.input--invalid]="formErrors.address"
                            id="address"
                            formControlName="address"
                            maxlength="35"
                            requiredIf="paymentType"
                            requiredIfValue="CC"
                        >
                        <div
                            *ngIf="formErrors.address"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.address }}
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="field form-row__item">
                        <div class="field__label-input-wrap">
                            <label
                                for="city"
                                class="label"
                            >
                                City
                            </label>
                            <input
                                class="input"
                                [class.input--invalid]="formErrors.city"
                                id="city"
                                formControlName="city"
                                maxlength="35"
                                requiredIf="paymentType"
                                requiredIfValue="CC"
                            >
                            <div
                                *ngIf="formErrors.city"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.city }}
                            </div>
                        </div>
                    </div>
                    <div class="field form-row__item">
                        <div class="field__label-input-wrap">
                            <label
                                for="state"
                                class="label"
                            >
                                State&#x2F;Province
                            </label>
                            <input
                                class="input"
                                [class.input--invalid]="formErrors.state"
                                id="state"
                                formControlName="state"
                                maxlength="10"
                                requiredIf="paymentType"
                                requiredIfValue="CC"
                            >
                            <div
                                *ngIf="formErrors.state"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.state }}
                            </div>
                        </div>
                    </div>
                    <div class="field form-row__item">
                        <div class="field__label-input-wrap">
                            <label
                                for="zip"
                                class="label"
                            >
                                Zip&#x2F;Postal Code
                            </label>
                            <input
                                class="input"
                                [class.input--invalid]="formErrors.zip"
                                id="zip"
                                formControlName="zip"
                                maxlength="10"
                                requiredIf="paymentType"
                                requiredIfValue="CC"
                            >
                            <div
                                *ngIf="formErrors.zip"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.zip }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p></p>
            <p>
                By clicking Submit, I agree to pay {{purchase.total | currency: 'USD': true}} according to the cardholder agreement.
            </p>
        </div>
        <div
            *ngIf="paymentType=='V'"
            class="field-list__item payment-option-item"
        >
            <div class="nested-fields">
                <div class="field  ">
                    <div class="field__label-input-wrap">
                        <label
                            for="voucher"
                            class="label"
                        >
                            Voucher Number
                        </label>
                        <input
                            class="input"
                            id="voucher"
                            name="voucher"
                            formControlName="voucher"
                            requiredIf="paymentType"
                            requiredIfValue="V"
                        >
                        <div
                            *ngIf="formErrors.voucher"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.voucher }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            *ngIf="paymentType=='ACH'"
            class="field-list__item payment-option-item"
        >
            <legend>E-Check Payment</legend>

            <div class="field ">
                <div class="field__label-input-wrap">
                    <label
                        for="credential"
                        class="label"
                    >
                        Account Type
                    </label>
                    <select
                        class="input input--select-menu"
                        id="accountType"
                        formControlName="accountType"
                        name="accountType"
                    >
                        <option value="checking">Checking</option>
                        <option value="savings">Savings</option>
                    </select>
                </div>
            </div>

            <img
                src="/assets/images/check-sample.png"
                style="width: 70%;"
                alt="Sample image of a check"
            >

            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="nameOnAccount"
                        class="label"
                    >
                        Name on account
                    </label>
                    <input
                        class="input input--large"
                        [class.input--invalid]="formErrors.nameOnCard"
                        id="nameOnAccount"
                        formControlName="nameOnAccount"
                        maxlength="22"
                        requiredIf="paymentType"
                        requiredIfValue="ACH"
                    >
                    <div
                        *ngIf="formErrors.nameOnAccount"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.nameOnAccount }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="routingNumber"
                            class="label"
                        >
                            Routing Number
                        </label>
                        <input
                            class="input input--medium"
                            [class.input--invalid]="formErrors.routingNumber"
                            id="routingNumber"
                            formControlName="routingNumber"
                            maxlength="9"
                            requiredIf="paymentType"
                            requiredIfValue="ACH"
                        >
                        <div
                            *ngIf="formErrors.routingNumber"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.routingNumber }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="routingNumberConfirm"
                            class="label"
                        >
                            Confirm Routing Number
                        </label>
                        <input
                            class="input input--medium"
                            [class.input--invalid]="formErrors.routingNumberConfirm"
                            id="routingNumberConfirm"
                            formControlName="routingNumberConfirm"
                            maxlength="9"
                            requiredIf="paymentType"
                            requiredIfValue="ACH"
                        >
                        <div
                            *ngIf="formErrors.routingNumberConfirm"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.routingNumberConfirm }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="accountNumber"
                            class="label"
                        >
                            Account Number
                        </label>
                        <input
                            class="input input--large"
                            [class.input--invalid]="formErrors.accountNumber"
                            id="accountNumber"
                            formControlName="accountNumber"
                            maxlength="17"
                            requiredIf="paymentType"
                            requiredIfValue="ACH"
                        >
                        <div
                            *ngIf="formErrors.accountNumber"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.accountNumber }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="accountNumberConfirm"
                            class="label"
                        >
                            Confirm Account Number
                        </label>
                        <input
                            class="input input--large"
                            [class.input--invalid]="formErrors.accountNumberConfirm"
                            id="accountNumberConfirm"
                            formControlName="accountNumberConfirm"
                            maxlength="17"
                            requiredIf="paymentType"
                            requiredIfValue="ACH"
                        >
                        <div
                            *ngIf="formErrors.accountNumberConfirm"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.accountNumberConfirm }}
                        </div>
                    </div>
                </div>
            </div>
            <p>
                By clicking 'Authorize Payment' below, I authorize The National Board for Respiratory Care to charge my {{accountType}} account on {{currentDate| amDateFormat: 'L'}}
           for the amount of {{purchase.total | currency: 'USD': true}} for the products/services listed above.
            </p>
        </div>
    </fieldset>
    <p *ngIf="purchase.total==0">
        You may apply for this examination at no cost. Read and accept the terms and press the submit button to continue.
    </p>
    <span *ngIf="!collectBirthday&&!collectDemographics">
        <span>
            <p>
                I certify that I have read the
                <a
                    href="https://www.nbrc.org/candidate-handbook"
                    target="_blank"
                >
                    NBRC Candidate Handbook
                </a>
                and believe that I comply with all of the admission policies for the examination for which I am applying. I certify that the information 
          I have submitted in this application and the enclosed documents are complete and correct to the best of my knowledge and belief. 
          I understand that, if the information I have submitted is found to be incomplete or inaccurate, my application may be rejected or my examination 
          results may be delayed, not released, or invalidated by the NBRC.
            </p>
            <p>I attest that the following are true:</p>
            <ul>
                <li>
                    I understand that I have an assigned eligibility period and failure to schedule an examination appointment within the assigned period will 
              result in expiration of the application and forfeiture of examination fees.
                </li>
                <li>
                    I understand the examination restrictions and penalties for misconduct during testing.
                </li>
                <li>
                    I understand my activity during testing will be monitored.
                </li>
                <li>
                    I understand that all NBRC examination content is copyrighted intellectual property and misuse of examination content will subject 
              me to civil and/or criminal penalties.
                </li>
                <li>
                    I understand the
                    <a
                        href="https://www.nbrc.org/je-policies"
                        target="_blank"
                    >
                        Judicial and Ethics Policies
                    </a>
                    of the NBRC.
                </li>
                <li>
                    I agree that the NBRC may release information about my credentialed status to state agencies that regulate the practice of respiratory 
              care, accredited respiratory care education programs, and the Commission on Accreditation for Respiratory Care (CoARC).
                </li>
                <li>
                    I acknowledge that being randomly selected for a graduation or CEU audit will require me to provide official transcripts and/or copies 
              of my CEU documentation.
                </li>
                <li>
                    I understand that the email address I provide with my application will be used to provide notifications about the status of my application 
              and/or credential.
                </li>
                <li>
                    I understand that I am responsible for notifying the NBRC of any change in my mailing and/or email address, and the NBRC shall not be 
              held responsible for non-receipt of official notices due to my failure to provide a current mailing and/or email address.
                </li>
            </ul>
        </span>
        <div
            [hidden]="!serverMessage"
            id="serverMessage"
            class="error-message field__error-message"
        >
            {{serverMessage}}
        </div>
        <div class="form-actions">
            <input
                [disabled]="(!paymentType &&  purchase.total != 0) || isPaymentProcessing"
                class="button form-actions__item"
                type="submit"
                value="Submit"
            >
            <button
                (click)="onCancel($event)"
                class="button button--secondary form-actions__item"
                type="button"
            >
                Cancel
            </button>
        </div>
    </span>
</form>
